import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useClubProductHttp } from '@/core/api/club-products'
import { ClubProduct, ClubProductPayload } from '@/core/models/club-product'

export type ClubProductCollection = {
    data: Array<ClubProduct>,
    meta?: MetaPayload,
    links?: any
}

const state: ClubProductCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const clubProductCollection: Module<ClubProductCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ClubProductCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ClubProductPayload) => {
                state.data.push(new ClubProduct(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useClubProductHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ClubProductCollection): ClubProductCollection => {
            return state
        }
    }
}
